export default __webpack_public_path__ + "static/media/030-croissant.111eb091.svg";